import React, { useContext, useEffect, useState } from "react";
import styles from "./index.module.scss";
import { NAV_LINKS } from "./constants";
// import right from "../../assets/images/right.png";
// import userIcon from "../../assets/images/userIcon.png";
// import userIconLight from "../../assets/images/userIconLight.png";
import brandLogo from "../../assets/images/brandLogo.png";
// import watchLaterImg from "../../assets/images/watchLater.png";
// import menuIcon from "../../assets/images/menu.svg";
import exclusiveIcon from "../../assets/images/exclusiveicon.png";
import premiumIcon from "../../assets/images/premiumicon.png";
import Login from "../Login/Login.js";
import { isMobileDevice, isTablet } from "../../utils/getPlatformInfo";
import feedbackIcon from "../../assets/images/feedback.png";
import {
  getActivePage,
  kFormatter,
  trimString,
} from "../../utils/common.utils";
import { useHistory } from "react-router";
import { useTheme } from "../../contexts/ThemeContext/ThemeContext";
import Signup from "../Signup/Signup";
import { UserContext } from "../../contexts/UserContext/UserContextProvider";
import { AuthManager } from "../../firebase/firebase";
import { ThemeSwitch } from "..";
import { Link, useLocation } from "react-router-dom";
// import { useScrollHandler } from "../../hooks/useScroll";
import { VideoPlayerContext } from "../../contexts/VideoPlayerContext/VideoPlayerContextProvider";
import { webinarContext } from "../../contexts/WebinarContext/WebinarContextProvider";
import { useWebinarPageContext } from "../../scenes/WebinarDetails";
import {
  ExclusiveType,
  URLADMIN,
  Webinar_status,
} from "../../AppConstants/TypeConstants";
import useQuery from "../../utils/useQuery";
import { ASSETS_BASE_URL } from "../../AppConstants/Constants";

// import closeBtn from "../../assets/images/close.png";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import {
  LOGOUT_BTN,
  SEARCH_BTN_CLICK,
  TRENDS_BTN_CLICK,
} from "../../AppConstants/AnalyticsEventName";
// import SearchModal from "./SearchModal";
import EditProfile from "./EditProfile/EditProfile";
import { scroller, ScrollLink } from "react-scroll";
// import AnimatedHeader from "../AnimatedHeader";
import { authContext } from "../../contexts/AuthContext/AuthContextProvider";
import JoinModal from "../../scenes/LandingPage/partials/JoinModal/JoinModal";
import DigitalAvatar from "../../scenes/DigitalAvatar";
// import camera from "../../assets/images/camIcon.png";
import { AvatarContext } from "../../contexts/AvatarContext/AvatarContextProvider";
import {
  EMPLOYEE_DASHBOARD_ROUTE,
  GET_FEATURED_ROUTE,
  HOME_ROUTE,
  RootRoute,
  TRENDS_ROUTE,
} from "../../AppConstants/Routes";
import { ConstantDataContext } from "../../contexts/ConstantContext/ConstantDataContextProvider";
import WatchLaterManager from "../../Managers/Users/WatchLater";
import BannerLottie from "../../scenes/WebinarDetails/partials/WebinarHeadCard/BannerLottie/BannerLottie.js";
import { hideSpecialityForProfession } from "../../AppData/Profession.js";
import AnouncementBar from "../AnouncementBar/index.js";
import {
  LOGOUT_CLICK_EVENT,
  TAB_CLICK_EVENT,
  WEBINAR_QUITED_EVENT,
} from "../../Clevertap/EventNames.ts";
import { getWebinarClickData } from "../../Clevertap/EventHandler.ts";
import { scrollTarget as scrollToComponent } from "../../utils/common.utils";
import NewFeatureTag from "../NewFeaturetag/index.tsx";

const routeNames = [
  {
    name: "Home",
    id: "home",
    url: `${ASSETS_BASE_URL}/images/dashboardHome.png`,
  },
  {
    name: `My Notes`,
    id: "notes",
    url: `${ASSETS_BASE_URL}/images/dashboardNotes.png`,
  },
  {
    name: `My Watchlist`,
    id: "myPlaylist",
    url: `${ASSETS_BASE_URL}/images/watchLater.png`,
  },

  {
    name: "Trending Shows",
    id: "trendingShows",
    url: `${ASSETS_BASE_URL}/images/dashboardLatestShows.png`,
    offset: isMobileDevice ? -150 : 150,
  },
  {
    name: "Academy",
    id: "academy",
    url: `${ASSETS_BASE_URL}/images/academy.png`,
    offset: isMobileDevice ? -150 : -100,
  },
  // {
  //   name: "Recently Added",
  //   id: "recently_added",
  //   url: `${ASSETS_BASE_URL}/images/dashboardRecentlyAdded.png`,
  //   offset: isMobileDevice ? -150 : -100,
  // },
  {
    name: `Webinar`,
    id: "webinar",
    url: `${ASSETS_BASE_URL}/images/dashboardWebinar.png`,
  },
];

const HISTORY_ACTIONS = ["POP", "REPLACE"];

const scoringData = [
  {
    name: "App Download",
    points: 100,
    info: "Download the app to earn more.",
  },
  {
    name: "Webinar",
    points: 50,
    info: "Attend webinar to earn more.",
  },
  {
    name: "Course",
    points: 20,
    info: "Enroll to course to earn more.",
  },
  {
    name: "Share",
    points: 15,
    info: "Share content with your peers to earn more points.",
  },
  {
    name: "Like/Rate",
    points: 1,
    info: "Rate and like the contents to earn more points.",
  },
  {
    name: "Feedback",
    points: 10,
    info: "Share your feedback to earn more points.",
  },
  {
    name: "Video/Podcast",
    points: 10,
    info: "Watch video/podcast to earn more points.",
  },
  {
    name: "Story/Reel",
    points: 5,
    info: "Watch story/reel to earn more points.",
  },
  {
    name: "Daily Visit",
    points: 1,
    info: "Visit regularly to earn more points.",
  },
];

const BadgeList = [
  {
    name: "badge1",
    img: `${ASSETS_BASE_URL}/images/badge1.png`,
  },
  {
    name: "badge2",
    img: `${ASSETS_BASE_URL}/images/badge2.png`,
  },
  {
    name: "badge3",
    img: `${ASSETS_BASE_URL}/images/badge3.png`,
  },
];

const routeIcons = {
  Home: `${ASSETS_BASE_URL}/images/dashboardHome.png`,
  LatestShows: `${ASSETS_BASE_URL}/images/dashboardLatestShows.png`,
  RecentlyAdded: `${ASSETS_BASE_URL}/images/dashboardRecentlyAdded.png`,
  Videos: `${ASSETS_BASE_URL}/images/dashboardVideos.png`,
  Webinar: `${ASSETS_BASE_URL}/images/dashboardWebinar.png`,
  MyNotes: `${ASSETS_BASE_URL}/images/dashboardNotes.png`,
};

const NavHeader = ({
  scrollValue,
  defaultBg,
  themeConstant = false,
  showNav = true,
  showBreadcrum = false,
  eventDetails = null,
  nativeBack = false,
  customBackHandler = null,
}) => {
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const { user, userBasicDetails, userMetadata } = useContext(UserContext);
  const { addWebinarTimespent, updateUserStateInWebinar } =
    useContext(webinarContext);
  const { handleScreen } = useContext(AvatarContext);
  const { isFullScreen } = useContext(VideoPlayerContext);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showAvatarModal, setShowAvatarModal] = useState(false);
  const { state } = useWebinarPageContext();
  const query = useQuery();

  let admin = query.get("admin");

  const { toggleSignInbtn, state: newAuthState } = useContext(authContext);
  const { showSignUpModal, showSignInModal, showJoinModal } = newAuthState;
  const [showUserDropDown, setShowUserDropDown] = useState(false);
  const [allWatchLater, setAllWatchLater] = useState([]);
  const {
    showSearch,
    setShowSearch,
    isAnalyticsAvailable,
    showAnnouncement,
    handleOpenUserFeedbackModal,
    remoteConfigData,
  } = useContext(ConstantDataContext);

  const pathname = getActivePage();
  const { isDark } = useTheme();
  const history = useHistory();
  const { search = "", hash = "" } = useLocation();

  useEffect(() => {
    if (showSearch) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.position = "unset";
    }
  }, [showSearch]);

  useEffect(() => {
    if (showSignUpModal || showSignInModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showSignUpModal, showSignInModal]);

  useEffect(() => {
    fetchAllWatchLater();
    return () => {
      WatchLaterManager._get.removeUserWatchLaterListener();
    };
  }, []);

  const fetchAllWatchLater = async () => {
    if (user) {
      WatchLaterManager._get.attachUserWatchLaterListener(
        user.uid,
        (res, err) => {
          if (err) {
            return;
          }
          setAllWatchLater(res);
        }
      );
    }
  };

  const handleSigninbtn = () => {
    setShowUserDropDown(false);
    toggleSignInbtn("showSignInModal", true);
  };

  const handleLogout = async () => {
    setShowUserDropDown(false);
    if (pathname.includes("/webinar/")) {
      if (admin && admin !== URLADMIN.admin) {
        await AuthManager.logout();
        redirectToHome();
        return;
      }
      await logoutFromEventPage();
    }
    addLogEvents(LOGOUT_CLICK_EVENT);
    addGAWithUserInfo(LOGOUT_BTN, { uid: user.uid || "" });
    await AuthManager.logout();
    redirectToHome();
  };

  const scrollTarget = (target, offset) => {
    // scroller.scrollTo(target, {
    //   smooth: true,
    //   offset: offset,
    //   duration: 700,
    //   delay: 100,
    // });

    scrollToComponent(`#${target}`);
  };
  const scrollToPage = async (target, offset) => {
    setShowUserDropDown(false);
    if (pathname !== HOME_ROUTE) {
      redirectToHome();
    }

    // this is just a temporary workaround not a best solution
    setTimeout(() => {
      if (target === "trendingShows") {
        scrollTarget(target);
        // setTimeout(() => {
        //   scrollTarget(target, offset);
        // }, 1000);
      } else {
        scrollTarget(target, offset);
      }
    }, 100);
  };

  useEffect(() => {
    if (showUserDropDown && isMobileDevice && !isTablet) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.position = "unset";
    }
  }, [showUserDropDown]);

  const handleCloseAvatar = () => {
    setShowAvatarModal(false);
    handleScreen("screen", "");
  };

  const logoutFromEventPage = async () => {
    addLogEvents(WEBINAR_QUITED_EVENT, getWebinarClickData(state.baseInfo));
    // update user status
    let userState =
      userBasicDetails && userBasicDetails.state
        ? userBasicDetails?.state
        : null;
    await updateUserStateInWebinar(
      user.uid,
      userState,
      state.baseInfo.id,
      "offline",
      true
    );
    if (
      user &&
      state.baseInfo &&
      state.baseInfo.status === Webinar_status.ONGOING
    ) {
      await addWebinarTimespent(
        user.uid,
        state.baseInfo.id,
        state.baseInfo.ongoingagendaid,
        null,
        state.baseInfo.status,
        true
      );
    }
  };

  const handleSearch = () => {
    addGAWithUserInfo(SEARCH_BTN_CLICK);
    setShowSearch(true);
  };

  const handleRoute = (value) => {
    setShowUserDropDown(false);
    if (value === pathname) {
      scroller.scrollToTop();
    } else {
      if (value === HOME_ROUTE) {
        return redirectToHome();
      }
      return history.push({
        pathname: value.startsWith("/") ? value : `/${value}`,
        search: search,
      });
    }
  };

  const handleEditProfile = (bool) => {
    return setShowEditProfile(bool);
  };
  const [showScoring, setShowScoring] = useState(false);
  // const topReached = scrollValue > (isMobileDevice ? 250 : 850);

  // const handleNativeBack = () => {
  //   // && history.length < 3
  //   if (pathname.includes("/webinar/")) {
  //     return redirectToHome();
  //   } else if (history.length <= 2) {
  //     return redirectToHome();
  //   }
  //   return history.goBack();
  // };

  const addLogEvents = (eventName, data = {}) => {
    addCleverTapAnalytics(eventName, data);
  };

  const redirectToHome = () => {
    return history.push({ pathname: RootRoute, search: search });
  };
  const handleTrends = () => {
    addGAWithUserInfo(TRENDS_BTN_CLICK);
    if (pathname === TRENDS_ROUTE) {
      return;
    }
    return history.push({ pathname: TRENDS_ROUTE, search: search });
  };

  return (
    <>
      {showAnnouncement && pathname === HOME_ROUTE && <AnouncementBar />}
      <div
        className={`${styles.wrapper}`}
        style={{
          top:
            showAnnouncement && !isMobileDevice && pathname === HOME_ROUTE
              ? "5rem"
              : 0,
          zIndex: isFullScreen && "10",
        }}
      >
        {user && (
          <div
            className={styles.feedbackTextDesktop}
            onClick={handleOpenUserFeedbackModal}
          >
            Feedback
          </div>
        )}
        <div
          className={styles.brandContainer}
          style={{
            color: themeConstant && "#fff",
          }}
        >
          {nativeBack &&
        //    !HISTORY_ACTIONS.includes(history?.action) && 
           (
            <div
              onClick={() =>
                nativeBack
                  ? history.goBack({ search: search })
                  : redirectToHome()
              }
              className={styles.backButton}
            >
              <img src={`${ASSETS_BASE_URL}/images/back.png`} alt="back" />
            </div>
          )}
          {customBackHandler && (
            <div
              onClick={() => {
                if (!customBackHandler.native) {
                  if (history?.action !== "POP") {
                    history.goBack({ search: search });
                  } else {
                    history.replace({
                      pathname: customBackHandler.nativePath,
                      search: search,
                    });
                  }
                } else {
                  customBackHandler?.handler();
                  window.scrollTo(0, 0);
                }
              }}
              className={styles.backButton}
            >
              <img src={`${ASSETS_BASE_URL}/images/back.png`} alt="back" />
            </div>
          )}
          <div onClick={() => redirectToHome()} className={styles.brandName}>
            <BrandName />
            {showBreadcrum && (
              <div
                className={styles.breadcrum}
                onClick={(e) => e.stopPropagation()}
              >
                {/* {pathname.split("/")[1]}
              <img src={right} alt=">" /> */}
                {eventDetails && trimString(eventDetails.title, 200)}
              </div>
            )}
          </div>
        </div>
        {!showBreadcrum && (
          <div className={styles.navSection}>
            <ul className={styles.navLinks}>
              {React.Children.toArray(
                NAV_LINKS.map((link) => {
                  return (
                    <Link
                      onClick={() =>
                        addLogEvents(TAB_CLICK_EVENT, { Tab: link.name })
                      }
                      to={{
                        pathname: link.url,
                        search: search,
                      }}
                      className={
                        link.url === pathname ? styles.active : styles.link
                      }
                      style={{
                        color: themeConstant && "#fff",
                      }}
                    >
                      {remoteConfigData["trends"]?.show &&
                      link.url === TRENDS_ROUTE ? (
                        <li>
                          {link.name}
                          {link.showTag && <NewFeatureTag tag={link.showTag} />}
                        </li>
                      ) : (
                        <li>
                          {link.name}
                          {link.showTag && <NewFeatureTag tag={link.showTag} />}
                        </li>
                      )}
                    </Link>
                  );
                })
              )}
            </ul>
          </div>
        )}
        <div className={styles.userLinks}>
          {user && remoteConfigData["trends"]?.show && (
            <svg
              width="20"
              height="19"
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={handleTrends}
              style={{ cursor: "pointer" }}
            >
              <g filter="url(#filter0_d_7_5)">
                <path
                  d="M16.5 2.56667C16.2348 2.56667 15.9804 2.46658 15.7929 2.28842C15.6054 2.11026 15.5 1.86862 15.5 1.61667C15.5 1.36471 15.6054 1.12307 15.7929 0.944915C15.9804 0.766755 16.2348 0.666666 16.5 0.666666H20.5C20.7652 0.666666 21.0196 0.766755 21.2071 0.944915C21.3946 1.12307 21.5 1.36471 21.5 1.61667V5.41667C21.5 5.66862 21.3946 5.91026 21.2071 6.08842C21.0196 6.26658 20.7652 6.36667 20.5 6.36667C20.2348 6.36667 19.9804 6.26658 19.7929 6.08842C19.6054 5.91026 19.5 5.66862 19.5 5.41667V3.90997L13.707 9.41332C13.5195 9.59141 13.2652 9.69146 13 9.69146C12.7348 9.69146 12.4805 9.59141 12.293 9.41332L9.5 6.75997L4.207 11.7883C4.0184 11.9614 3.7658 12.0571 3.5036 12.055C3.2414 12.0528 2.99059 11.9529 2.80518 11.7767C2.61977 11.6006 2.5146 11.3623 2.51233 11.1132C2.51005 10.8642 2.61084 10.6242 2.793 10.445L8.793 4.74502C8.98053 4.56692 9.23484 4.46687 9.5 4.46687C9.76516 4.46687 10.0195 4.56692 10.207 4.74502L13 7.39837L18.086 2.56667H16.5ZM4.5 15.8667V18.7167C4.5 18.9686 4.39464 19.2103 4.20711 19.3884C4.01957 19.5666 3.76522 19.6667 3.5 19.6667C3.23478 19.6667 2.98043 19.5666 2.79289 19.3884C2.60536 19.2103 2.5 18.9686 2.5 18.7167V15.8667C2.5 15.6147 2.60536 15.3731 2.79289 15.1949C2.98043 15.0168 3.23478 14.9167 3.5 14.9167C3.76522 14.9167 4.01957 15.0168 4.20711 15.1949C4.39464 15.3731 4.5 15.6147 4.5 15.8667ZM9.5 12.0667C9.5 11.8147 9.39464 11.5731 9.20711 11.3949C9.01957 11.2168 8.76522 11.1167 8.5 11.1167C8.23478 11.1167 7.98043 11.2168 7.79289 11.3949C7.60536 11.5731 7.5 11.8147 7.5 12.0667V18.7167C7.5 18.9686 7.60536 19.2103 7.79289 19.3884C7.98043 19.5666 8.23478 19.6667 8.5 19.6667C8.76522 19.6667 9.01957 19.5666 9.20711 19.3884C9.39464 19.2103 9.5 18.9686 9.5 18.7167V12.0667ZM13.5 13.0167C13.7652 13.0167 14.0196 13.1168 14.2071 13.2949C14.3946 13.4731 14.5 13.7147 14.5 13.9667V18.7167C14.5 18.9686 14.3946 19.2103 14.2071 19.3884C14.0196 19.5666 13.7652 19.6667 13.5 19.6667C13.2348 19.6667 12.9804 19.5666 12.7929 19.3884C12.6054 19.2103 12.5 18.9686 12.5 18.7167V13.9667C12.5 13.7147 12.6054 13.4731 12.7929 13.2949C12.9804 13.1168 13.2348 13.0167 13.5 13.0167ZM19.5 9.21667C19.5 8.96471 19.3946 8.72307 19.2071 8.54491C19.0196 8.36676 18.7652 8.26667 18.5 8.26667C18.2348 8.26667 17.9804 8.36676 17.7929 8.54491C17.6054 8.72307 17.5 8.96471 17.5 9.21667V18.7167C17.5 18.9686 17.6054 19.2103 17.7929 19.3884C17.9804 19.5666 18.2348 19.6667 18.5 19.6667C18.7652 19.6667 19.0196 19.5666 19.2071 19.3884C19.3946 19.2103 19.5 18.9686 19.5 18.7167V9.21667Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7_5"
                  x="-1.5"
                  y="0.666666"
                  width="27"
                  height="27"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7_5"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7_5"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          )}

          {user && (
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={handleSearch}
              style={{ cursor: "pointer" }}
            >
              <path
                d="M8.21031 15.9379C12.1871 15.9379 15.4108 12.7142 15.4108 8.7374C15.4108 4.76066 12.1871 1.53687 8.21031 1.53687C4.23356 1.53687 1.00977 4.76066 1.00977 8.7374C1.00977 12.7142 4.23356 15.9379 8.21031 15.9379Z"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.2107 17.7378L13.2954 13.8225"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}

          {/* <div
            onClick={() => {
              setShowUserDropDown((prev) => !prev);
            }}
            className={styles.signInIcon}
          >
            {isMobileDevice ? null : (
              <> */}
          {/* {!user ? (
                  <span
                    style={{
                      color: themeConstant && "#fff",
                    }}
                  >
                    signin
                    <img
                      src={
                        themeConstant
                          ? userIcon
                          : isDark
                          ? userIcon
                          : userIconLight
                      }
                      alt="signin"
                    />
                  </span>
                ) : (
                  // <span
                  //   style={{
                  //     color: themeConstant && "#fff",
                  //     fontSize: "1rem",
                  //   }}
                  // >
                  //   {user.displayName}
                  // </span>
                  <>
                    {userBasicDetails && (
                      <>
                        <div
                          className={styles.namedProfileIcon}
                        >{`${userBasicDetails.firstName[0].toUpperCase()} ${userBasicDetails.lastName[0].toUpperCase()}`}</div>

                        <div
                          style={{
                            color: themeConstant && "#fff",
                            fontSize: "1rem",
                            marginLeft: "1rem",
                          }}
                        >
                          {`${userBasicDetails.firstName} ${userBasicDetails.lastName}`}
                        </div>
                      </>
                    )}
                  </>
                )} */}
          {/* </>
            )}
          </div> */}
          {showUserDropDown && (
            <>
              <div
                onClick={() => {
                  setShowScoring(false);
                  setShowUserDropDown(false);
                }}
                className={"modalOverlay"}
              />
              <div className={styles.drawerWrapper}>
                <div className={styles.header}>
                  {/* <div className={styles.logo}>
                    <img src={brandLogo} alt="Docflix" />
                    <span>Docflix</span>
                  </div> */}
                  {isDark ? "Dark Mode" : "Docflix Mode"}
                  <ThemeSwitch />
                  {/* <img
                    onClick={() => setShowUserDropDown(false)}
                    src={closeBtn}
                    alt="close"
                    style={{ cursor: "pointer" }}
                  /> */}
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "3rem",
                    }}
                  >
                    <div className={styles.userProfile}>
                      {userBasicDetails && userBasicDetails.avatar ? (
                        <img
                          src={
                            userBasicDetails.avatar.key === "Avatar"
                              ? userBasicDetails.avatar.avatar_face_img
                              : userBasicDetails.avatar.cam_image
                          }
                          className={styles.avatar_face_img}
                          alt="avatar_img"
                        />
                      ) : (
                        <div className={styles.namedProfileIcon}>
                          {userBasicDetails
                            ? `${userBasicDetails.firstName[0].toUpperCase()} ${userBasicDetails.lastName[0].toUpperCase()}`
                            : "NA"}
                        </div>
                      )}
                      {/* <div
                        onClick={() => setShowAvatarModal(true)}
                        className={styles.cameraIcon}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 30 30"
                          width="20px"
                          height="20px"
                          style={{ transform: "rotate(270deg)" }}
                        >
                          <g id="surface79131335">
                            <path
                              style={{
                                stroke: "none",
                                fillRule: "nonzero",
                                fill: "rgb(100%,100%,100%)",
                                fillOpacity: "1",
                              }}
                              d="M 22.828125 3 C 22.316406 3 21.804688 3.195312 21.414062 3.585938 L 19 6 L 24 11 L 26.414062 8.585938 C 27.195312 7.804688 27.195312 6.539062 26.414062 5.757812 L 24.242188 3.585938 C 23.851562 3.195312 23.339844 3 22.828125 3 Z M 17 8 L 5.261719 19.738281 C 5.261719 19.738281 6.175781 19.65625 6.519531 20 C 6.863281 20.34375 6.578125 22.578125 7 23 C 7.421875 23.421875 9.644531 23.125 9.964844 23.441406 C 10.28125 23.761719 10.261719 24.738281 10.261719 24.738281 L 22 13 Z M 4 23 L 3.058594 25.671875 C 3.019531 25.777344 3 25.886719 3 26 C 3 26.550781 3.449219 27 4 27 C 4.113281 27 4.222656 26.980469 4.328125 26.941406 C 4.332031 26.941406 4.335938 26.941406 4.335938 26.941406 L 4.363281 26.933594 C 4.367188 26.929688 4.367188 26.929688 4.367188 26.929688 L 7 26 Z M 4 23 "
                            />
                          </g>
                        </svg>
                      </div> */}
                      {/* <img
                      src={`${ASSETS_BASE_URL}/images/profile.png`}
                      alt="profile"
                    /> */}
                      <div className={styles.userDesc}>
                        <div className={styles.username}>
                          {userBasicDetails
                            ? `${
                                hideSpecialityForProfession.includes(
                                  userBasicDetails?.profession?.trim()
                                )
                                  ? "Hi,"
                                  : "Dr."
                              } ${userBasicDetails.firstName} ${
                                userBasicDetails.lastName
                              }`
                            : "Hi There!"}
                          {userMetadata &&
                            userMetadata.current_plan &&
                            userMetadata.current_plan !==
                              ExclusiveType.FREE && (
                              <img
                                src={
                                  userMetadata.current_plan ===
                                  ExclusiveType.PREMIUM
                                    ? premiumIcon
                                    : userMetadata.current_plan ===
                                      ExclusiveType.EXCLUSIVE
                                    ? exclusiveIcon
                                    : ""
                                }
                                alt={
                                  userMetadata.current_plan ===
                                  ExclusiveType.PREMIUM
                                    ? ExclusiveType.PREMIUM
                                    : userMetadata.current_plan ===
                                      ExclusiveType.EXCLUSIVE
                                    ? exclusiveIcon
                                    : ""
                                }
                                style={{
                                  height: "2rem",
                                  width: "2rem",
                                  objectFit: "contain",
                                  marginLeft: "0.5rem",
                                }}
                              />
                            )}
                        </div>
                        <div className={styles.profile}>
                          {user && userBasicDetails
                            ? userBasicDetails.profession
                            : null}
                        </div>
                        {user && (
                          <div
                            className="d-flex"
                            style={{ alignItems: "center", gap: "1rem" }}
                          >
                            <button
                              className={`btn ${styles.editBtn}`}
                              onClick={() => handleEditProfile(true)}
                            >
                              Edit Profile
                            </button>

                            {isAnalyticsAvailable && (
                              <div
                                role="button"
                                className={`cursor-pointer ${styles.editBtn}`}
                                onClick={() =>
                                  handleRoute("employee_dashboard")
                                }
                              >
                                Analytics Report
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div style={{ position: "absolute", right: "-30%" }}>
                        <img
                          src={`${ASSETS_BASE_URL}/images/ProfileBanner.png`}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className={styles.routesSection}>
                      {routeNames.map((route) => {
                        if (route.id === "notes" && !user) {
                          return null;
                        }
                        if (
                          route.id === "trendingShows" ||
                          route.id === "recently_added"
                        ) {
                          return (
                            <div
                              key={route.id}
                              onClick={() => {
                                addLogEvents(TAB_CLICK_EVENT, {
                                  Tab: route.name,
                                });
                                scrollToPage(route.id, route.offset);
                              }}
                              className={styles.routeBox}
                            >
                              <div className={styles.route}>
                                <img
                                  className={styles.routeIcon}
                                  src={route.url}
                                  alt="route"
                                />
                                {route.name}
                              </div>
                            </div>
                          );
                        }
                        return (
                          <div
                            key={route.id}
                            onClick={() => {
                              addLogEvents(TAB_CLICK_EVENT, {
                                Tab: route.name,
                              });
                              handleRoute(route.id);
                            }}
                            style={{
                              backgroundImage: `${
                                pathname === `/${route.id}`
                                  ? "linear-gradient( rgba(0,0,0,.5), rgba(0,0,0,.5) )"
                                  : "none"
                              }`,
                              boxShadow: `${
                                pathname === `/${route.id}`
                                  ? "0px 6px 6px 2px rgb(0 0 0 / 58%)"
                                  : "none"
                              }`,
                            }}
                            className={styles.routeBox}
                          >
                            <div className={styles.route}>
                              <img
                                className={styles.routeIcon}
                                src={route.url}
                                alt="route"
                              />
                              {route.name}
                              {route.id === "myPlaylist" &&
                                allWatchLater &&
                                allWatchLater.length > 0 && (
                                  <div className={styles.watchLaterCount}>
                                    {kFormatter(allWatchLater.length)}
                                  </div>
                                )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {user && (
                    <div className={styles.badgesWrappper}>
                      <div className={styles.header}>
                        Your Score -{" "}
                        {userBasicDetails?.score ? userBasicDetails?.score : 0}{" "}
                        points
                        <img
                          onClick={() => setShowScoring(true)}
                          src={`${ASSETS_BASE_URL}/images/infoIcon.png`}
                          className={styles.infoImg}
                          alt=""
                        />
                      </div>
                      <div
                        onClick={handleOpenUserFeedbackModal}
                        className={styles.feedbackText}
                      >
                        <img src={feedbackIcon} alt="" />
                        <div className={styles.txt}>Feedback</div>
                      </div>

                      {/* {remoteConfigData["featuredDocflixForm"]?.enable && (
                        <div
                          className="cursor-pointer"
                          onClick={() => handleRoute(GET_FEATURED_ROUTE)}
                        >
                          <img
                            width={"100%"}
                            src={
                              remoteConfigData["featuredDocflixForm"]?.CTAImage
                            }
                            alt=""
                          />
                        </div>
                      )} */}

                      {showScoring && (
                        <div className={styles.scoresWrapper}>
                          <img
                            className={styles.backImg}
                            onClick={() => setShowScoring(false)}
                            src={`${ASSETS_BASE_URL}/images/backBtn.png`}
                            alt={"backBtn"}
                          />
                          <div className={styles.scoreHeader}>
                            <div className={styles.title}>
                              Scoring System - <span>points</span>
                            </div>
                            <img
                              className={styles.scoringImg}
                              src={`${ASSETS_BASE_URL}/images/Scoring.png`}
                              alt={"backBtn"}
                            />
                          </div>

                          <div className={styles.scoreCardWrapper}>
                            {scoringData.map((score) => {
                              return (
                                <div className={styles.scoreCard}>
                                  <div className={styles.scoreCardheader}>
                                    {score.name} -{" "}
                                    <span>{score.points} points</span>
                                  </div>
                                  <div>{score.info}</div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {/* <div style={{ position: "absolute", right: "-30%" }}>
                      <img
                        src={`${ASSETS_BASE_URL}/images/BadgesBanner.png`}
                        alt=""
                      />
                    </div> */}
                      {/* <div className={styles.badgesList}>
                      {BadgeList.map((badge) => {
                        return (
                          <div key={badge.name} className={styles.badge}>
                            <img src={badge.img} alt="badgeImg" />
                          </div>
                        );
                      })}
                    </div> */}
                    </div>
                  )}
                </div>

                <div className={styles.FooterbtnWrapper}>
                  <button
                    onClick={() => setShowUserDropDown(false)}
                    className={`btn ${styles.loginBtn}`}
                  >
                    Close
                  </button>
                  <button
                    onClick={user ? handleLogout : handleSigninbtn}
                    className={`btn ${styles.loginBtn}`}
                  >
                    {user ? "Log out" : "Login"}
                  </button>
                  {showEditProfile && (
                    <EditProfile handleEditProfile={handleEditProfile} />
                  )}
                </div>
              </div>
              {/* <div
                className={styles.userDropDown}
                style={{ display: showUserDropDown && "block" }}
              >
                {!user && (
                  <div
                    className={styles.userDropDownList}
                    onClick={handleSigninbtn}
                  >
                    Sign in / Register
                  </div>
                )}

                <div
                  className={styles.userDropDownList}
                  style={{ alignItems: "center" }}
                >
                  {isDark ? "Dark Mode" : "Docflix Mode"}
                  <ThemeSwitch />
                </div>
                {user && (
                  <div
                    className={styles.userDropDownList}
                    style={{ marginTop: "-0.7rem" }}
                    onClick={handleNoteButton}
                  >
                    Notes
                  </div>
                )}
                {user && (
                  <div
                    className={styles.userDropDownList}
                    onClick={handleLogout}
                  >
                    Logout
                  </div>
                )}
              </div> */}
            </>
          )}

          <div
            style={{ cursor: "pointer" }}
            className={styles.menuIcon}
            onClick={() => setShowUserDropDown((prev) => !prev)}
          >
            <svg
              width="19"
              height="19"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.5 3.125H13.5C13.75 3.125 14 2.90625 14 2.625V1.375C14 1.125 13.75 0.875 13.5 0.875H0.5C0.21875 0.875 0 1.125 0 1.375V2.625C0 2.90625 0.21875 3.125 0.5 3.125ZM0.5 8.125H13.5C13.75 8.125 14 7.90625 14 7.625V6.375C14 6.125 13.75 5.875 13.5 5.875H0.5C0.21875 5.875 0 6.125 0 6.375V7.625C0 7.90625 0.21875 8.125 0.5 8.125ZM0.5 13.125H13.5C13.75 13.125 14 12.9062 14 12.625V11.375C14 11.125 13.75 10.875 13.5 10.875H0.5C0.21875 10.875 0 11.125 0 11.375V12.625C0 12.9062 0.21875 13.125 0.5 13.125Z"
                fill="#fff"
              />
            </svg>
          </div>
        </div>
      </div>
      {showSignInModal && <Login />}
      {showJoinModal && <JoinModal />}
      {/* {showSignInModal && <Login old />} */}
      {showSignUpModal && <Signup />}
      {showAvatarModal && (
        <DigitalAvatar handleCloseAvatar={handleCloseAvatar} />
      )}
    </>
  );
};

export default NavHeader;

export const BrandName = () => {
  const { remoteConfigData } = useContext(ConstantDataContext);

  const activeSeason = remoteConfigData["festivalData"]["activeSeason"];

  if (
    remoteConfigData &&
    remoteConfigData.showFestivalAnimation &&
    activeSeason &&
    remoteConfigData[
      remoteConfigData?.["festivalData"]?.[activeSeason]?.["navLogo"]
    ]
  ) {
    return (
      <BannerLottie
        animationData={{
          json: true,
          data: remoteConfigData[
            remoteConfigData["festivalData"][activeSeason]["navLogo"]
          ],
        }}
        customClass={styles.lottieContainer}
      />
    );
  } else {
    return (
      <>
        <img className={styles.brandLogo} src={brandLogo} alt="Docflix" />
        <span>Docflix</span>
      </>
    );
  }
};
